import { _t } from '../base.js'

function addCloseIconToLoginModal() {
    $('.login-window-in .user-action-in').prepend(`<div class="login-close"></div>`)
    $('.login-close').click(function () {
        $('body').removeClass('login-window-visible user-action-visible')
    })
}

function addAccountSidebar() {
    if ($('.id--7').length || $('.id--8').length) {
        const sidebarInner = document.querySelector('.sidebar-inner')

        if (sidebarInner) {
            const accountSidebar = document.createElement('div')
            accountSidebar.classList.add('account-sidebar')

            accountSidebar.innerHTML = `
            <p>${_t('contactUs')}</p>
            <div class="account-sidebar__item account-sidebar__item--phone">
                <a href="tel:+421915748723">+421 915 748 723</a>
            </div>
            <div class="account-sidebar__item account-sidebar__item--mail">
                <a href="mailto:${_t('cocoEmail')}">
                    ${_t('cocoEmail')}
                </a>
            </div>
        `

            sidebarInner.appendChild(accountSidebar)
        }
    }
}

export function initAccount() {
    addCloseIconToLoginModal()
    addAccountSidebar()
}
